import React, { useEffect, useRef, useState } from "react";

import Box from "./Box";
import Button from "./Button";
import DownIcon from "../assets/chevron-white.svg";
import Text from "./Text";

const height = 30;

function SelectText({ children }) {
  return (
    <Text
      color="white"
      uppercase
      fontSize={[12, 12, 12, 12]}
      transition="color 200ms"
      fontWeight={500}
      fontFamily="ibmPlexMono"
      lineHeight={1}
      letterSpacing="2px"
    >
      {children}
    </Text>
  );
}

function Option({ value, handleClick }) {
  return (
    <Button
      onClick={handleClick}
      height={height}
      px={10}
      display="flex"
      alignItems="center"
      width="100%"
    >
      <SelectText>{value}</SelectText>
    </Button>
  );
}

function CustomSelect({ items, defaultText, value, handleChange }) {
  const [open, setOpen] = useState(false);
  const selectRef = useRef();

  useEffect(() => {
    const handleClick = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

  return (
    <Box position="relative" pb={height}>
      <Box display="none">
        <select value={value} readOnly>
          <option value="">{defaultText}</option>
          {items.map((item) => {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            );
          })}
        </select>
      </Box>

      <Box
        ref={selectRef}
        display="inline-block"
        position="absolute"
        width="100%"
        maxWidth={[null, 360, null, null]}
        zIndex={100}
        backgroundColor="black"
      >
        <Button
          onClick={() => {
            setOpen(!open);
          }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px="10px"
          height={height}
          width="100%"
        >
          <SelectText>
            {value === "" || !value ? defaultText : value}
          </SelectText>
          <Box
            transform={open ? "rotate(270deg)" : "rotate(90deg)"}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <DownIcon />
          </Box>
        </Button>
        <Box
          display={open ? "block" : "none"}
          position="relative"
          maxHeight={270}
          overflow="auto"
        >
          <Option
            value="All"
            handleClick={() => {
              setOpen(false);
              handleChange("");
            }}
          />
          {items.map((item) => {
            return (
              <Option
                key={item}
                value={item}
                handleClick={() => {
                  setOpen(false);
                  handleChange(item);
                }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default CustomSelect;
